import {useFormValidation} from "~/composables/validations/useFormValidation";
import type {AddressErrors, InputAddress} from "~/types/addressTypes";
import type {Address} from "~/composables/store/user/address/interface";
import {useIsHouseHomeType} from "~/composables/store/services/service_inputs";

export function useValidateAddress(address: InputAddress|Address, isBcc: boolean = false):AddressErrors {
    const {
        errors,
        validateStreet, validateHouse, validateCity, validateApartment, validateEntrance, validateFloor
    } = useFormValidation()

    validateStreet(address?.street)
    validateCity(address?.city?.location_id)
    // «Квартира», «Подъезд» и «Этаж» обязательны только в мини-аппе БЦК —
    // на обычном сайте эти поля исторически опциональны
    if (isBcc) {
        // в мини-аппе номер дома — отдельное обязательное поле, а не часть строки улицы
        validateHouse(address?.house)
        // у частного дома нет квартиры, подъезда и этажа — поля скрыты в форме,
        // требовать их не нужно (см. InputAddress.vue и useIsHouseHomeType)
        if (!useIsHouseHomeType().value) {
            validateApartment(address?.flat)
            validateEntrance(address?.entrance)
            validateFloor(address?.floor)
        }
    }
    const addressErrors:AddressErrors = {
        isError: false,
        street: {
            isError: false,
            text: ''
        },
        city: {
            isError: false,
            text: ''
        },
        house: {
            isError: false,
            text: ''
        },
        flat: {
            isError: false,
            text: ''
        },
        entrance: {
            isError: false,
            text: ''
        },
        floor: {
            isError: false,
            text: ''
        },
    }
    if (errors.value.street) {
        addressErrors.isError = true
        addressErrors.street = {
            isError: true,
            text: errors.value.street
        }
    }
    if (errors.value.house) {
        addressErrors.isError = true
        addressErrors.house = {
            isError: true,
            text: errors.value.house
        }
    }
    if (errors.value.city) {
        addressErrors.isError = true
        addressErrors.city = {
            isError: true,
            text: errors.value.city
        }
    }
    if (errors.value.apartment) {
        addressErrors.isError = true
        addressErrors.flat = {
            isError: true,
            text: errors.value.apartment
        }
    }
    if (errors.value.entrance) {
        addressErrors.isError = true
        addressErrors.entrance = {
            isError: true,
            text: errors.value.entrance
        }
    }
    if (errors.value.floor) {
        addressErrors.isError = true
        addressErrors.floor = {
            isError: true,
            text: errors.value.floor
        }
    }
    return addressErrors
}